<template>
  <infinite-loading
    @infinite="call"
    spinner="waveDots"
    :identifier="infiniteId"
    >
    <div slot="spinner"> {{ loading }} </div>  
    <div slot="no-more"> {{ noMore }} </div>
    <div slot="no-results">{{ noResults }}</div>  
  </infinite-loading>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";

export default {
  props: {
    infiniteId: {
      type: Number,
      default: 0
    },
    call: {
      type: Function,
      default: null
    },
    loading: {
      type: String,
      default: 'Loading...'
    },
    noMore: {
      type: String,
      default: 'No More Listing'
    },
    noResults: {
      type: String,
      default: 'No results Found'
    }
  },
  components: {
    InfiniteLoading
  }
}
</script>